/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.auditoriasinventario': 'Inventory audits',
  'auditoriasinventario.NumeroDocumento': 'Document code',
  'auditoriasinventario.FechaCreacion': 'Creation date',
  'auditoriasinventario.BodegaOrigenDescripcion': 'Bodega origin description',
  'auditoriasinventario.BodegaDestinoDescripcion': 'Destination winery description',
  'auditoriasinventario.DocumentoRelacionado': 'Related document',
  'auditoriasinventario.CodigoDocumentoPadre': 'Parent document',
  'auditoriasinventario.EstadoDocumento': 'Document status',
  'auditoriasinventario.Bodegas': 'Warehouse',
  'auditoriasinventario.FechaInicial': 'Initial date',
  'auditoriasinventario.datosDocumento': 'Document Data',
  'auditoriasinventario.detallesDocumento': 'Document details',
  'auditoriasinventario.bodegaDestino': 'Destiny warehouse',
  'auditoriasinventario.observaciones': 'Observations',
  'auditoriasinventario.etapaDescripcion': 'Stage',
  'auditoriasinventario.bodegaOrigen': 'Origin warehouse',
  'auditoriasinventario.busquedaDetalles': 'Search details',
  'auditoriasinventario.FechaFinal': 'Final date',
  'auditoriasinventario.ConteoUnico': 'Single count',
  'auditoriasinventario.Detalles.CodigoBarras': 'Código barras',
  'auditoriasinventario.Detalles.DescripcionItem': 'Item description',
  'auditoriasinventario.Detalles.CantidadRecibida': 'Received amount',
  'auditoriasinventario.Detalles.Serial': 'Serial',
  'auditoriasinventario.Detalles.Lote': 'Lot',
  'auditoriasinventario.Detalles.FechaVencimiento': 'Expiration date',
  'auditoriasinventario.Detalles.Division': 'Division',
  'auditoriasinventario.Detalles.crearDetalleDocumento': 'Create detail document',
  'auditoriasinventario.Detalles.editarDetalleDocumento': 'Edit detail document',
  'auditoriasinventario.conteoParcial': 'Partial count',
  'auditoriasinventario.conteoTotal': 'Total count',
  'auditoriasinventario.realizarConteo': 'Counting',
  'gestionAuditorias.titulo.primerConteo': '1° Count',
  'gestionAuditorias.titulo.segundoConteo': '2° Count',
  'auditoriasinventario.alerta.fechasInicialInvalida': 'The initial date must be less than the final date',
  'auditoriasinventario.alerta.fechaIncompleta': 'Enter the two dates to be able to perform the search',
  'auditoriasinventario.alerta.loteNoIngresado': 'The selected item requires entering a lot',
  'auditoriasinventario.alerta.serialNoIngresado': 'The selected item requires entering a serial',
  'auditoriasinventario.alerta.fechaVencimientoNoIngresada':
    'The selected item requires entering an expiration date',
  'auditoriasinventario.alerta.auditoriaCreada':
    'The audit is not yet counted, please request the authorization for the count',
};
